import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';

@Injectable()
export class ExtSearchService {

  constructor(
    private h: HttpClientService
  ) { }

  getExtSearchConfig(configKey: string) {
    return this.h.get(`koncentro-common/apps-config?config_key=${configKey}`);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/ext-search/ext-search.service.ts